import axios, { AxiosResponse } from 'axios';
import getApiBaseUrl from '../GetServer';

export interface ChatBot {
  id: number;
  idCliente: number;
  key: string;
  nombre: string;
  color: string;
  icono: string;
  status: number;
  idAgente: number;
  nombreAgente: string;
  mensajeChat?: string;
  allowedDomains?: string;
  redFace?: string;
  redInstagran?: string;
  redGmail?: string;
}

// Nueva interfaz sin paginación
export interface ChatBotsApiResponse {
  statusCode: number;
  message: string;
  data: ChatBot[]; // Solo recibimos el array de datos
}

export const getChatbots = async (): Promise<ChatBotsApiResponse> => {
  const baseUrl = getApiBaseUrl();
  const endpoint = `${baseUrl}dash/chatbots`; // Eliminamos parámetros de query

  const token = localStorage.getItem('token');
  if (!token) throw new Error('Token no disponible');

  const response = await axios.get(endpoint, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (response.data.statusCode !== 200) {
    throw new Error(response.data.message);
  }

  return {
    statusCode: response.data.statusCode,
    message: response.data.message,
    data: response.data.data // Mapeamos directamente al array
  };
};